import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 12px;
  background: #fff;
  margin-top: 8px;
`;
export const Content = styled.div``;

export const Header = styled.div`
  width: 100%;
  display: flex;
  padding: 10px 20px;
  align-items: center;
  gap: 20px;
  border-radius: 10px 10px 0px 0px;
  background: #f4f4f4;

  p {
    color: #000;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const SubHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  span {
    color: #000;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;
